module.exports = __webpack_public_path__ + "static/media/beta_tag.a536cdfa.svg";